import styled, { css } from 'styled-components';
import { FlexBox, MagicBox } from '@brg/ui';

const COVER_VIEWTYPES_1_9 = ['t-shape', 'fixed-ratio-large'];

/**
 * Константы лейаута
 */
export class LayoutConst {
    /**
     * Размеры экрана для конвертации
     */
    public static screen = {
        l_16: 1600,
        mac13: 1440,
        l_12: 1280,
        l: 1199,
        m_1024: 1024,
        m: 992,
        md: 940,
        s: 744,
        sm: 568,
        xsm: 375,
        xxxsm: 320,
        height: {
            projectCover: 920
        },
    };

    /**
     * Размеры контейнера
     */
    public static container = {
        l: 1152,
        m: 712,
        tablet: 760,
        s: 720,
        xs: 712,
    };

    public static header = {
        l: 64,
        m: 52,
        s: 48,
    }

    public static footer = {
        l: 32,
        s: 29,
    }

    /**
     * Размеры проекта
     */
    public static projectCard = {
        l: { w: 270, h: 380, h1_9: 297 },
        m: { w: 220, h: 310, h1_9: 242 },
        tablet: { w: 166, h: 234, h1_9: 158 },
        s: { w: 166, h: 243, h1_9: 158 },
        xs: { w: 166, h: 234 },
    };
    public static bookCard = {
        l: { w: 270, h: 380, h1_9: 297 },
        m: { w: 204, h: 287 },
        s: { w: 166, h: 234 },
        xs: { w: 145, h: 204 },
    }
    public static opaCard = {
        sm: { w: 166, h: 166 },
        s: { w: 362, h: 362 },
    }

    public static mapCard = {
        l: { w: 192, h: 270 },
        m: { w: 163, h: 230 },
        s: { w: 130, h: 182 },
    }

    public static competitionCard = {
        l: { w: 564, h: 397 },
        //m: { w: 460, h: 310 },
        m: { w: 432, h: 287 },
        s: { w: 348, h: 243 },
    };

    public static projectCover = {
        // l: { w: 568, h: 798, }, previus val
        l: { w: 564, h: 792, },
        // m: { w: 366, h: 514, },
        m: { w: 432, h: 594, },
        // s: { w: 372, h: 523 },
        s: { w: 348, h: 490 },
        xs: { w: 269, h: 375 },
    };

    public static spCover = {
        square: {
            l: { w: 452, h: 452, },
            m: { w: 336, h: 336, },
            s: { w: 284, h: 284, },
            // xs: { w: 284, h: 284, },
        },
        orientation: {
            l: { h: 250, },
            m: { h: 195, },
            s: { h: 157, },
            xs: { h: 140, },
        },
        padding: {
            l: 56,
            m: 40,
            s: 32,
            xs: 24
        },
        cardPadding: {
            l: 16,
            m: 10,
        }
    }

    public static projectContainer = {
        l: 1152,
        // m: 737,
        m: 888,
    }

    // 2000 - (200 * 4) = 1200 / 3

    public static projectCardGap = {
        l: (LayoutConst.container.l - LayoutConst.projectCard.l.w * 4) / 3,
        m: (LayoutConst.container.m - LayoutConst.projectCard.m.w * 4) / 3,
        tablet: 16,
        s: 10,
    };
}

/**
 * Основной контейнер приложения
 */
export const CoreContainer = styled.div<{ minOffset?: boolean, bottomOffset?: number, isCGRAVE?: boolean }>`
    box-sizing: content-box;
    width: ${LayoutConst.container.l + 'px'};
    margin-right: auto;
    margin-left: auto;
    margin-top: 32px;

    @media(max-width: ${LayoutConst.screen.l}px) {
        margin-top: 24px;
        width: ${LayoutConst.container.xs}px;
        padding-left: 16px;
        padding-right: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        width: calc(100vw - 20px);
        padding-left: 10px;
        padding-right: 10px;
        margin-top: 16px;
        justify-content: center;
    }
`;

/**
 * Контейнер для карточки презентации
 */

export const CorePsnCardContainer = styled(MagicBox) <{ viewType?: string, noGrid?: boolean, isSquare?: boolean, sizeMult?: number }>`
box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
grid-column: span 2;
width: 100%;
max-width: 100%;
height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;


@media (min-width: ${LayoutConst.screen.s + 'px'}) {
  height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  min-width: ${LayoutConst.projectCard.s.w + 'px'};
  min-height: ${({ viewType }) => `${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
  max-height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}}`}px;
}

@media (min-width: ${LayoutConst.screen.m + 'px'}) {
  height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  min-width: ${LayoutConst.projectCard.m.w + 'px'};
  min-height: ${({ viewType }) => `${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
  max-height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}}`}px;
}

@media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
    height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.l.w + 'px'};
    min-height: ${({ viewType }) => `${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    max-height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}}`}px;
}

@media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) { // На 768px проблема "поехавшего грида сохранялась - 767 норм
  ${({ noGrid, isSquare, viewType }) => {
        const ratio = COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 1 / 1.9 : viewType === 'fixed-ratio-small' ? 1 / 1.48 : 1.407;
        const width = noGrid || ['fixed-ratio-small', 'fixed-ratio-large', 't-shape'].includes(String(viewType)) ? 100 : 50;
        const padding = noGrid ? 20 : 15;
        const calculatedWidth = `calc(${width}vw - ${padding}px)`;
        const calculatedHeight = isSquare ? calculatedWidth : `calc((${width}vw - ${padding}px) * ${ratio})`;
        return css`
      // width: ${calculatedWidth};
      height: ${calculatedHeight};
      // max-width: ${calculatedWidth};
      max-height: ${calculatedHeight};
      min-width: ${calculatedWidth};
      min-height: ${calculatedHeight};
    `}
    }
}

`;

/**
 * Контейнер для карточки проекта
 */
export const CoreProjectCardContainer = styled(MagicBox) <{ noGrid?: boolean, isCGRAVE?: boolean }>`
    flex-direction: column;
    background: ${({ isCGRAVE }) => isCGRAVE ? '#464645' : ''};
    width: ${LayoutConst.projectCard.l.w + 'px'};
    height: ${LayoutConst.projectCard.l.h + 'px'};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: ${LayoutConst.projectCard.l.w + 'px'};
        height: ${LayoutConst.projectCard.l.h + 'px'};
        min-width: ${LayoutConst.projectCard.l.w + 'px'};
        min-height: ${LayoutConst.projectCard.l.h + 'px'};
        max-width: ${LayoutConst.projectCard.l.w + 'px'};
        max-height: ${LayoutConst.projectCard.l.h + 'px'};
    }

    @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
        width: ${LayoutConst.projectCard.m.w + 'px'};
        height: ${LayoutConst.projectCard.m.h + 'px'};
        min-width: ${LayoutConst.projectCard.m.w + 'px'};
        min-height: ${LayoutConst.projectCard.m.h + 'px'};
        max-width: ${LayoutConst.projectCard.m.w + 'px'};
        max-height: ${LayoutConst.projectCard.m.h + 'px'};
    }

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        width: ${LayoutConst.projectCard.xs.w + 'px'};
        height: ${LayoutConst.projectCard.xs.h + 'px'};
        min-width: ${LayoutConst.projectCard.xs.w + 'px'};
        min-height: ${LayoutConst.projectCard.xs.h + 'px'};
        max-width: ${LayoutConst.projectCard.xs.w + 'px'};
        max-height: ${LayoutConst.projectCard.xs.h + 'px'};
    }
   
    @media (max-width: ${LayoutConst.screen.s - 1}px) { // На 768px проблема "поехавшего грида сохранялась - 767 Раньше было 940px
        ${({ noGrid }) => {
        const width = noGrid ? 100 : 50;
        const padding = noGrid ? 20 : 15;
        return css`
          width: calc(${width}vw - ${padding}px);
          height: calc((${width}vw - ${padding}px) * 1.407);
          max-width: calc(${width}vw - ${padding}px);
          max-height: calc((${width}vw - ${padding}px) * 1.407);
          min-width: calc(${width}vw - ${padding}px);
          min-height: calc((${width}vw - ${padding}px) * 1.407);
        `}
    }
    }
`;

export const ScalableOPAFlexBoxSquare = styled(FlexBox)`
    // width: ${LayoutConst.projectCard.l.w + 'px'};
    // height: ${LayoutConst.projectCard.l.w + 'px'};
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);

    width: ${LayoutConst.projectCard.l.w + 'px'};
    height: ${LayoutConst.projectCard.l.w + 'px'};
    min-width: ${LayoutConst.projectCard.l.w + 'px'};
    min-height: ${LayoutConst.projectCard.l.w + 'px'};
    max-width: ${LayoutConst.projectCard.l.w + 'px'};
    max-height: ${LayoutConst.projectCard.l.w + 'px'};

    @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
        width: ${LayoutConst.projectCard.m.w + 'px'};
        height: ${LayoutConst.projectCard.m.w + 'px'};
        min-width: ${LayoutConst.projectCard.m.w + 'px'};
        min-height: ${LayoutConst.projectCard.m.w + 'px'};
        max-width: ${LayoutConst.projectCard.m.w + 'px'};
        max-height: ${LayoutConst.projectCard.m.w + 'px'};
    }

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        width: ${LayoutConst.opaCard.sm.w + 'px'};
        height: ${LayoutConst.opaCard.sm.w + 'px'};
        min-width: ${LayoutConst.opaCard.sm.w + 'px'};
        min-height: ${LayoutConst.opaCard.sm.w + 'px'};
        max-width: ${LayoutConst.opaCard.sm.w + 'px'};
        max-height: ${LayoutConst.opaCard.sm.w + 'px'};
    }

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        width: calc(50vw - 15px);
        height: calc(50vw - 15px);
        min-width: calc(50vw - 15px);
        min-height: calc(50vw - 15px);
        max-width: calc(50vw - 15px);
        max-height: calc(50vw - 15px);
    }
`;

export const ScalableFlexBoxSquare = styled(FlexBox) <{ isGroupModal?: boolean, twoMobileColumns?: boolean }>`
    width: ${LayoutConst.projectCard.l.w + 'px'};
    height: ${LayoutConst.projectCard.l.w + 'px'};

    ${({ isGroupModal, twoMobileColumns }) => (isGroupModal || twoMobileColumns) ? css`
    @media (min-width: 320px) {
        width: calc(50vw - 15px);
        height: calc(50vw - 15px);
        min-width: calc(50vw - 15px);
        min-height: calc(50vw - 15px);
        max-width: calc(50vw - 15px);
        max-height: calc(50vw - 15px);
    }
` : css`
    @media (min-width: 320px) {
        width: calc(100vw - 20px);
        height: calc(100vw - 32px);
        min-width: calc(100vw - 20px);
        min-height: calc(100vw - 32px);
        max-width: calc(100vw - 32px);
        max-height: calc(100vw - 32px);
    }
`}

    @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        width: ${LayoutConst.projectCard.s.w + 'px'};
        height: ${LayoutConst.projectCard.s.w + 'px'};
        min-width: ${LayoutConst.projectCard.s.w + 'px'};
        min-height: ${LayoutConst.projectCard.s.w + 'px'};
        max-width: ${LayoutConst.projectCard.s.w + 'px'};
        max-height: ${LayoutConst.projectCard.s.w + 'px'};
    }

    @media (min-width: ${LayoutConst.screen.m + 'px'}) {
        width: ${LayoutConst.projectCard.m.w + 'px'};
        height: ${LayoutConst.projectCard.m.w + 'px'};
        min-width: ${LayoutConst.projectCard.m.w + 'px'};
        min-height: ${LayoutConst.projectCard.m.w + 'px'};
        max-width: ${LayoutConst.projectCard.m.w + 'px'};
        max-height: ${LayoutConst.projectCard.m.w + 'px'};
    }

    @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
        width: ${LayoutConst.projectCard.l.w + 'px'};
        height: ${LayoutConst.projectCard.l.w + 'px'};
        min-width: ${LayoutConst.projectCard.l.w + 'px'};
        min-height: ${LayoutConst.projectCard.l.w + 'px'};
        max-width: ${LayoutConst.projectCard.l.w + 'px'};
        max-height: ${LayoutConst.projectCard.l.w + 'px'};
    }
`;

export const ScalableFlexBoxWidth = styled(FlexBox) <{ isGroupModal?: boolean, twoMobileColumns?: boolean, tooltipOpen?: boolean }>`
    width: ${LayoutConst.projectCard.l.w + 'px'};
    position: relative;
    z-index: ${({ tooltipOpen }) => tooltipOpen ? 3 : 2};

    ${({ isGroupModal, twoMobileColumns }) => (isGroupModal || twoMobileColumns) ? css`
    @media (min-width: 320px) {
        width: calc(50vw - 15px);
        min-width: calc(50vw - 15px);
        max-width: calc(50vw - 15px);
    }
` : css`
    @media (min-width: 320px) {
        width: calc(100vw - 32px);
        min-width: calc(100vw - 32px);
        max-width: calc(100vw - 32px);
    }
`};

    @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        width: ${LayoutConst.projectCard.s.w + 'px'};
        min-width: ${LayoutConst.projectCard.s.w + 'px'};
        max-width: ${LayoutConst.projectCard.s.w + 'px'};

        ${({ isGroupModal }) => isGroupModal && css`
            max-height: 202px;
            height: 202px;
            min-height: 202px;
        `}
    }

    @media (min-width: ${LayoutConst.screen.m + 'px'}) {
        width: ${LayoutConst.projectCard.m.w + 'px'};
        min-width: ${LayoutConst.projectCard.m.w + 'px'};
        max-width: ${LayoutConst.projectCard.m.w + 'px'};

        ${({ isGroupModal }) => isGroupModal && css`
            max-height: 256px;
            height: 256px;
            min-height: 256px;
        `}
    }

    @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
        width: ${LayoutConst.projectCard.l.w + 'px'};
        min-width: ${LayoutConst.projectCard.l.w + 'px'};
        max-width: ${LayoutConst.projectCard.l.w + 'px'};

        ${({ isGroupModal }) => isGroupModal && css`
            max-height: 320px;
            height: 320px;
            min-height: 320px;
        `}
    }
`;
import styled, { css } from 'styled-components';
import { FlexBox, MagicBox } from '@brg/ui';

const COVER_VIEWTYPES_1_9 = ['t-shape', 'fixed-ratio-large'];

/**
 * Константы лейаута
 */
export class LayoutConst {
    /**
     * Размеры экрана для конвертации
     */
    public static screen = {
        l_16: 1600,
        mac13: 1440,
        l_12: 1280,
        l: 1199,
        m_1024: 1024,
        m: 992,
        md: 940,
        s: 744,
        sm: 568,
        xsm: 375,
        xxxsm: 320,
        height: {
            projectCover: 920
        },
    };

    /**
     * Размеры контейнера
     */
    public static container = {
        l: 1152,
        m: 712,
        tablet: 760,
        s: 720,
        xs: 712,
    };

    public static header = {
        l: 64,
        m: 52,
        s: 48,
    }

    public static footer = {
        l: 32,
        s: 29,
    }

    /**
     * Размеры проекта
     */
    public static projectCard = {
        l: { w: 270, h: 380, h1_9: 297 },
        m: { w: 220, h: 310, h1_9: 242 },
        tablet: { w: 166, h: 234, h1_9: 158 },
        s: { w: 166, h: 243, h1_9: 158 },
        xs: { w: 166, h: 234 },
    };
    public static bookCard = {
        l: { w: 270, h: 380, h1_9: 297 },
        m: { w: 204, h: 287 },
        s: { w: 166, h: 234 },
        xs: { w: 145, h: 204 },
    }
    public static opaCard = {
        sm: { w: 166, h: 166 },
        s: { w: 362, h: 362 },
    }

    public static mapCard = {
        l: { w: 192, h: 270 },
        m: { w: 163, h: 230 },
        s: { w: 130, h: 182 },
    }

    public static competitionCard = {
        l: { w: 564, h: 397 },
        //m: { w: 460, h: 310 },
        m: { w: 432, h: 287 },
        s: { w: 348, h: 243 },
    };

    public static projectCover = {
        // l: { w: 568, h: 798, }, previus val
        l: { w: 564, h: 792, },
        // m: { w: 366, h: 514, },
        m: { w: 432, h: 594, },
        // s: { w: 372, h: 523 },
        s: { w: 348, h: 490 },
        xs: { w: 269, h: 375 },
    };

    public static spCover = {
        square: {
            l: { w: 452, h: 452, },
            m: { w: 336, h: 336, },
            s: { w: 284, h: 284, },
            // xs: { w: 284, h: 284, },
        },
        orientation: {
            l: { h: 250, },
            m: { h: 195, },
            s: { h: 157, },
            xs: { h: 140, },
        },
        padding: {
            l: 56,
            m: 40,
            s: 32,
            xs: 24
        },
        cardPadding: {
            l: 16,
            m: 10,
        }
    }

    public static projectContainer = {
        l: 1152,
        // m: 737,
        m: 888,
    }

    // 2000 - (200 * 4) = 1200 / 3

    public static projectCardGap = {
        l: (LayoutConst.container.l - LayoutConst.projectCard.l.w * 4) / 3,
        m: (LayoutConst.container.m - LayoutConst.projectCard.m.w * 4) / 3,
        tablet: 16,
        s: 10,
    };
}

/**
 * Основной контейнер приложения
 */
export const CoreContainer = styled.div<{ minOffset?: boolean, bottomOffset?: number, isCGRAVE?: boolean }>`
    box-sizing: content-box;
    width: ${LayoutConst.container.l + 'px'};
    margin-right: auto;
    margin-left: auto;
    margin-top: 32px;

    @media(max-width: ${LayoutConst.screen.l}px) {
        margin-top: 24px;
        width: ${LayoutConst.container.xs}px;
        padding-left: 16px;
        padding-right: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        width: calc(100vw - 20px);
        padding-left: 10px;
        padding-right: 10px;
        margin-top: 16px;
        justify-content: center;
    }
`;

/**
 * Контейнер для карточки презентации
 */

export const CorePsnCardContainer = styled(MagicBox) <{ viewType?: string, noGrid?: boolean, isSquare?: boolean, sizeMult?: number }>`
box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
grid-column: span 2;
width: 100%;
max-width: 100%;
height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;


@media (min-width: ${LayoutConst.screen.s + 'px'}) {
  height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  min-width: ${LayoutConst.projectCard.s.w + 'px'};
  min-height: ${({ viewType }) => `${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
  max-height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.s[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}}`}px;
}

@media (min-width: ${LayoutConst.screen.m + 'px'}) {
  height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
  min-width: ${LayoutConst.projectCard.m.w + 'px'};
  min-height: ${({ viewType }) => `${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
  max-height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.m[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}}`}px;
}

@media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
    height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}`}px;
    min-width: ${LayoutConst.projectCard.l.w + 'px'};
    min-height: ${({ viewType }) => `${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h']}`}px;
    max-height: ${({ viewType, sizeMult }) => `${LayoutConst.projectCard.l[COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 'h1_9' : 'h'] * (sizeMult || 1)}}`}px;
}

@media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) { // На 768px проблема "поехавшего грида сохранялась - 767 норм
  ${({ noGrid, isSquare, viewType }) => {
        const ratio = COVER_VIEWTYPES_1_9.includes(String(viewType)) ? 1 / 1.9 : viewType === 'fixed-ratio-small' ? 1 / 1.48 : 1.407;
        const width = noGrid || ['fixed-ratio-small', 'fixed-ratio-large', 't-shape'].includes(String(viewType)) ? 100 : 50;
        const padding = noGrid ? 20 : 15;
        const calculatedWidth = `calc(${width}vw - ${padding}px)`;
        const calculatedHeight = isSquare ? calculatedWidth : `calc((${width}vw - ${padding}px) * ${ratio})`;
        return css`
      // width: ${calculatedWidth};
      height: ${calculatedHeight};
      // max-width: ${calculatedWidth};
      max-height: ${calculatedHeight};
      min-width: ${calculatedWidth};
      min-height: ${calculatedHeight};
    `}
    }
}

`;

/**
 * Контейнер для карточки проекта
 */
export const CoreProjectCardContainer = styled(MagicBox) <{ noGrid?: boolean, isCGRAVE?: boolean }>`
    flex-direction: column;
    background: ${({ isCGRAVE }) => isCGRAVE ? '#464645' : ''};
    width: ${LayoutConst.projectCard.l.w + 'px'};
    height: ${LayoutConst.projectCard.l.h + 'px'};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: ${LayoutConst.projectCard.l.w + 'px'};
        height: ${LayoutConst.projectCard.l.h + 'px'};
        min-width: ${LayoutConst.projectCard.l.w + 'px'};
        min-height: ${LayoutConst.projectCard.l.h + 'px'};
        max-width: ${LayoutConst.projectCard.l.w + 'px'};
        max-height: ${LayoutConst.projectCard.l.h + 'px'};
    }

    @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
        width: ${LayoutConst.projectCard.m.w + 'px'};
        height: ${LayoutConst.projectCard.m.h + 'px'};
        min-width: ${LayoutConst.projectCard.m.w + 'px'};
        min-height: ${LayoutConst.projectCard.m.h + 'px'};
        max-width: ${LayoutConst.projectCard.m.w + 'px'};
        max-height: ${LayoutConst.projectCard.m.h + 'px'};
    }

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        width: ${LayoutConst.projectCard.xs.w + 'px'};
        height: ${LayoutConst.projectCard.xs.h + 'px'};
        min-width: ${LayoutConst.projectCard.xs.w + 'px'};
        min-height: ${LayoutConst.projectCard.xs.h + 'px'};
        max-width: ${LayoutConst.projectCard.xs.w + 'px'};
        max-height: ${LayoutConst.projectCard.xs.h + 'px'};
    }
   
    @media (max-width: ${LayoutConst.screen.s - 1}px) { // На 768px проблема "поехавшего грида сохранялась - 767 Раньше было 940px
        ${({ noGrid }) => {
        const width = noGrid ? 100 : 50;
        const padding = noGrid ? 20 : 15;
        return css`
          width: calc(${width}vw - ${padding}px);
          height: calc((${width}vw - ${padding}px) * 1.407);
          max-width: calc(${width}vw - ${padding}px);
          max-height: calc((${width}vw - ${padding}px) * 1.407);
          min-width: calc(${width}vw - ${padding}px);
          min-height: calc((${width}vw - ${padding}px) * 1.407);
        `}
    }
    }
`;

export const ScalableOPAFlexBoxSquare = styled(FlexBox)`
    // width: ${LayoutConst.projectCard.l.w + 'px'};
    // height: ${LayoutConst.projectCard.l.w + 'px'};
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);

    width: ${LayoutConst.projectCard.l.w + 'px'};
    height: ${LayoutConst.projectCard.l.w + 'px'};
    min-width: ${LayoutConst.projectCard.l.w + 'px'};
    min-height: ${LayoutConst.projectCard.l.w + 'px'};
    max-width: ${LayoutConst.projectCard.l.w + 'px'};
    max-height: ${LayoutConst.projectCard.l.w + 'px'};

    @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
        width: ${LayoutConst.projectCard.m.w + 'px'};
        height: ${LayoutConst.projectCard.m.w + 'px'};
        min-width: ${LayoutConst.projectCard.m.w + 'px'};
        min-height: ${LayoutConst.projectCard.m.w + 'px'};
        max-width: ${LayoutConst.projectCard.m.w + 'px'};
        max-height: ${LayoutConst.projectCard.m.w + 'px'};
    }

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        width: ${LayoutConst.opaCard.sm.w + 'px'};
        height: ${LayoutConst.opaCard.sm.w + 'px'};
        min-width: ${LayoutConst.opaCard.sm.w + 'px'};
        min-height: ${LayoutConst.opaCard.sm.w + 'px'};
        max-width: ${LayoutConst.opaCard.sm.w + 'px'};
        max-height: ${LayoutConst.opaCard.sm.w + 'px'};
    }

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        width: calc(50vw - 15px);
        height: calc(50vw - 15px);
        min-width: calc(50vw - 15px);
        min-height: calc(50vw - 15px);
        max-width: calc(50vw - 15px);
        max-height: calc(50vw - 15px);
    }
`;

export const ScalableFlexBoxSquare = styled(FlexBox) <{ isGroupModal?: boolean, twoMobileColumns?: boolean }>`
    width: ${LayoutConst.projectCard.l.w + 'px'};
    height: ${LayoutConst.projectCard.l.w + 'px'};

    ${({ isGroupModal, twoMobileColumns }) => (isGroupModal || twoMobileColumns) ? css`
    @media (min-width: 320px) {
        width: calc(50vw - 15px);
        height: calc(50vw - 15px);
        min-width: calc(50vw - 15px);
        min-height: calc(50vw - 15px);
        max-width: calc(50vw - 15px);
        max-height: calc(50vw - 15px);
    }
` : css`
    @media (min-width: 320px) {
        width: calc(100vw - 20px);
        height: calc(100vw - 32px);
        min-width: calc(100vw - 20px);
        min-height: calc(100vw - 32px);
        max-width: calc(100vw - 32px);
        max-height: calc(100vw - 32px);
    }
`}

    @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        width: ${LayoutConst.projectCard.s.w + 'px'};
        height: ${LayoutConst.projectCard.s.w + 'px'};
        min-width: ${LayoutConst.projectCard.s.w + 'px'};
        min-height: ${LayoutConst.projectCard.s.w + 'px'};
        max-width: ${LayoutConst.projectCard.s.w + 'px'};
        max-height: ${LayoutConst.projectCard.s.w + 'px'};
    }

    @media (min-width: ${LayoutConst.screen.m + 'px'}) {
        width: ${LayoutConst.projectCard.m.w + 'px'};
        height: ${LayoutConst.projectCard.m.w + 'px'};
        min-width: ${LayoutConst.projectCard.m.w + 'px'};
        min-height: ${LayoutConst.projectCard.m.w + 'px'};
        max-width: ${LayoutConst.projectCard.m.w + 'px'};
        max-height: ${LayoutConst.projectCard.m.w + 'px'};
    }

    @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
        width: ${LayoutConst.projectCard.l.w + 'px'};
        height: ${LayoutConst.projectCard.l.w + 'px'};
        min-width: ${LayoutConst.projectCard.l.w + 'px'};
        min-height: ${LayoutConst.projectCard.l.w + 'px'};
        max-width: ${LayoutConst.projectCard.l.w + 'px'};
        max-height: ${LayoutConst.projectCard.l.w + 'px'};
    }
`;

export const ScalableFlexBoxWidth = styled(FlexBox) <{ isGroupModal?: boolean, twoMobileColumns?: boolean, tooltipOpen?: boolean }>`
    width: ${LayoutConst.projectCard.l.w + 'px'};
    position: relative;
    z-index: ${({ tooltipOpen }) => tooltipOpen ? 3 : 2};

    ${({ isGroupModal, twoMobileColumns }) => (isGroupModal || twoMobileColumns) ? css`
    @media (min-width: 320px) {
        width: calc(50vw - 15px);
        min-width: calc(50vw - 15px);
        max-width: calc(50vw - 15px);
    }
` : css`
    @media (min-width: 320px) {
        width: calc(100vw - 32px);
        min-width: calc(100vw - 32px);
        max-width: calc(100vw - 32px);
    }
`};

    @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        width: ${LayoutConst.projectCard.s.w + 'px'};
        min-width: ${LayoutConst.projectCard.s.w + 'px'};
        max-width: ${LayoutConst.projectCard.s.w + 'px'};

        ${({ isGroupModal }) => isGroupModal && css`
            max-height: 202px;
            height: 202px;
            min-height: 202px;
        `}
    }

    @media (min-width: ${LayoutConst.screen.m + 'px'}) {
        width: ${LayoutConst.projectCard.m.w + 'px'};
        min-width: ${LayoutConst.projectCard.m.w + 'px'};
        max-width: ${LayoutConst.projectCard.m.w + 'px'};

        ${({ isGroupModal }) => isGroupModal && css`
            max-height: 256px;
            height: 256px;
            min-height: 256px;
        `}
    }

    @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
        width: ${LayoutConst.projectCard.l.w + 'px'};
        min-width: ${LayoutConst.projectCard.l.w + 'px'};
        max-width: ${LayoutConst.projectCard.l.w + 'px'};

        ${({ isGroupModal }) => isGroupModal && css`
            max-height: 320px;
            height: 320px;
            min-height: 320px;
        `}
    }
`;
